import React from 'react';
import Alert from 'react-bootstrap/Alert';
function CategorySuggestion(props) {
    const recommendedUid = props.currentItem.taskDetails.recommendation?.categoryUid
    let showAlert = true
    let matchedCategory = null

    var onCategorySelect = function(){
        props.onCategorySelect(props.categories.find(cate=>cate.value === recommendedUid))
    }

    if(recommendedUid!==undefined){
        const matched = props.selectedCategories.filter(cate=>cate.id === recommendedUid).length
        if(matched>0){
        showAlert=false
        }else{
            matchedCategory = props.categories.find(cate=>cate.value === recommendedUid)
        }
    }else{
        showAlert=false
    }
    
    return(
        <>
        {showAlert && matchedCategory!==undefined && <Alert variant='info' onClick={onCategorySelect}>
            Suggested Category: {matchedCategory.label}
        </Alert >
        }
        </>
    )
}
export default CategorySuggestion